import React, { useEffect, Fragment } from 'react';
import { useParams } from 'react-router-dom';
import { CDataTable, CPagination } from '@coreui/react';
import SpinnerWithContainer from '../components/SpinnerWithContainer';
import { useSelector } from 'react-redux';
import { useActions } from '../hooks/useActions';
import { getUserSteps } from '../actions/usersActions';

const fields = [
  { key: 'date', label: 'Date' },
  // { key: "steps", label: "Steps" },
  { key: 'sms', label: 'Steps Reported via SMS' },
  { key: 'google', label: 'Steps Pulled from API' },
  { key: 'goal', label: 'Goal' },
  { key: 'goalType', label: 'Goal Type' },
];

function UserDataPage(props) {
  // get userId from URL params
  const params = useParams();

  // get required data from store
  const { loadingUserSteps, userSteps } = useSelector((state) => state.users);

  // bind dispatch to action creators
  const getUserStepsAction = useActions(getUserSteps);

  // useEffect to load user steps
  useEffect(() => {
    getUserStepsAction({ userId: params.id });
  }, [getUserStepsAction, params.id]);

  return (
    <div>
      <h1>Data for User {params.userId}</h1>
      {loadingUserSteps ? (
        <SpinnerWithContainer />
      ) : (
        <Fragment>
          <CDataTable
            items={userSteps.data}
            fields={fields}
            itemsPerPage={50}
            scopedSlots={{
              goal: (item) => <td>{item.goal ? item.goal : 'Not Set'}</td>,
              goalType: (item) => (
                <td>{item.goalType ? item.goalType : 'N/A'}</td>
              ),
              sms: (item) => <td>{item.sms ? item.sms : 'N/A'}</td>,
              google: (item) => <td>{item.google ? item.google : 'N/A'}</td>,
            }}
          />
          {userSteps.totalPages > 1 && (
            <CPagination
              activePage={parseInt(userSteps.currentPage)}
              pages={userSteps.totalPages}
              onActivePageChange={(i) =>
                getUserStepsAction({ userId: params.id, page: i })
              }
            ></CPagination>
          )}
        </Fragment>
      )}
    </div>
  );
}

export default UserDataPage;
